import { ContentPageFeature } from '../ContentPage';

export const HomePageFeature: React.FC<Content.HomePage> = (page) => <ContentPageFeature {...page} />;
